module.exports = __webpack_public_path__ + "static/media/70_tn.0b895c26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/70_tn.jpg
// module id = 556
// module chunks = 0